import React from "react"
import classNames from "classnames"

import { IRCAFinding, IRootCauseAnalysisActions } from "../.."

import CategoryFinding from "./CategoryFinding"
import CardFinding from "./CardFinding"

export interface Props {
    finding: IRCAFinding
    actions: IRootCauseAnalysisActions
}

export const Finding = ({ finding, actions }: Props): JSX.Element => {
    const { id, nodeType, isMarkedAsRootCause } = finding

    const childrenFindings = finding.children

    // RCA children needs separate styling
    // To show that it's a different type of RCA
    const areChildrenRCA =
        Array.isArray(childrenFindings) &&
        childrenFindings.some((child) =>
            ["IshikawaRCA", "FiveWhysRCA"].includes(child.nodeType),
        )

    const isRCA = ["IshikawaRCA", "FiveWhysRCA"].includes(finding.nodeType)

    const isCategory = finding.nodeType === "Category"

    const isFinding = ["IshikawaFinding", "FiveWhysFinding"].includes(
        finding.nodeType,
    )

    const isDashedBorderShown = !isRCA && areChildrenRCA

    const childContainerClasses = classNames(
        "tw-flex tw-flex-col tw-gap-2 tw-pt-2",
        {
            "theme-note": isDashedBorderShown,
            "tw--mt-4": isDashedBorderShown,
            "tw-pt-6": isDashedBorderShown,
            "tw-pb-2": isDashedBorderShown,
            "tw-px-2": isDashedBorderShown,
        },
    )
    const indentationClasses = classNames({
        "tw-pl-6": isFinding,
    })

    return (
        <div
            data-ft-component="findingContainer"
            data-ft-id={id}
            data-ft-title={finding.content}
            data-ft-type={nodeType}
            data-ft-is-marked-as-root-cause={isMarkedAsRootCause}
        >
            {isCategory && (
                <CategoryFinding finding={finding} actions={actions} />
            )}
            {isFinding && <CardFinding finding={finding} actions={actions} />}

            {!!childrenFindings && childrenFindings.length > 0 && (
                <div
                    className={indentationClasses}
                    data-ft-component="childrenWrapper"
                >
                    <div
                        className={childContainerClasses}
                        data-ft-component="children"
                        data-ft-count={childrenFindings.length}
                        data-ft-id={id}
                    >
                        {childrenFindings.map((findingChild) => (
                            <Finding
                                key={findingChild.id}
                                finding={findingChild}
                                actions={actions}
                            />
                        ))}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Finding
